/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M1.9393 7.682A1.5 1.5 0 0 0 1.5 8.7426v6.5148a1.5 1.5 0 0 0 .4393 1.0606l5.7427 5.7427a1.5 1.5 0 0 0 1.0606.4393h6.5148c.3978 0 .7793-.158 1.0606-.4393l5.7427-5.7427a1.4999 1.4999 0 0 0 .4393-1.0606V8.7426a1.5 1.5 0 0 0-.4393-1.0606L16.318 1.9393A1.4999 1.4999 0 0 0 15.2574 1.5H8.7426a1.5 1.5 0 0 0-1.0606.4393L1.9393 7.682Zm-1.837.2842a3 3 0 0 1 .7756-1.344c0-.0001 0 0 0 0L6.6213.8786A3 3 0 0 1 8.7426 0h6.5148a3 3 0 0 1 2.1213.8787l5.7426 5.7426A3 3 0 0 1 24 8.7426v6.5148a3 3 0 0 1-.8787 2.1213l-5.7426 5.7426A3 3 0 0 1 15.2574 24H8.7426a3 3 0 0 1-2.1213-.8787L.8787 17.3787A3 3 0 0 1 0 15.2574V8.7426c0-.2644.035-.5253.1022-.7764Zm16.2845.7076L13.0607 12l3.3268 3.3268a.75.75 0 0 1-1.0607 1.0607L12 13.0606l-3.3262 3.3262c-.2929.2929-.7684.2935-1.0613.0007a.75.75 0 0 1 0-1.0607L10.9393 12 7.6126 8.6732a.75.75 0 1 1 1.0606-1.0607L12 10.9393l3.3268-3.3268a.75.75 0 0 1 1.0607 0c.2928.2929.2922.7684-.0007 1.0613.0002-.0002-.0002.0002 0 0Z"
    clipRule="evenodd"
  />,
  'Error'
);
